<template>
  <div class="content">
    <Memento />
    <b-row>
      <b-col class="col-12 d-flex justify-content-center">
        <h4>ЗӨВЛӨМЖ</h4>
      </b-col>
      <b-col class="col-4">
        <img src="../assets/images/recommend-image.png" class="img-fluid" />
      </b-col>
      <b-col class="col-7">
        <h5>Компьютер дээр хичээллэхдээ дараах цагийг баримтлаарай.</h5>
        <table class="table table-bordered">
          <thead>
            <tr>
              <th scope="col">Нас</th>
              <th scope="col">Хамгийн багадаа</th>
              <th scope="col">Хамгийн ихдээ</th>
              <th scope="col">Анхаарал төвлөрөлт</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(item, i) in items" :key="i.item">
              <th
                scope="row"
                class="age"
                :class="{
                  yellow: i === 0,
                  green: i === 1,
                  blue: i === 2,
                  greenT: i === 3,
                }"
              >
                {{ item.age }}
              </th>
              <td>{{ item.Time0 }} минут</td>
              <td>{{ item.Time1 }} минут</td>
              <td>{{ item.attention }} минут</td>
            </tr>
          </tbody>
        </table>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import Memento from "../components/Memento.vue";
export default {
  data() {
    return {
      items: [
        { age: "6-8", Time0: "45", Time1: "90", attention: "5-10" },
        { age: "9-11", Time0: "60", Time1: "120", attention: "10-15" },
        { age: "12-14", Time0: "90", Time1: "180", attention: "40" },
        { age: "15-18", Time0: "120", Time1: "270", attention: "50" },
      ],
      age: 11,
    };
  },
  components: {
    Memento,
  },
};
</script>

<style scoped>
.content {
  background-color: #f8f5e4;
  padding: 50px 80px 150px 50px;
}
h4 {
  color: #f9850c;
  font-size: 2.1875em;
  font-weight: bold;
}
h5 {
  color: #000000;
  text-align: center;
  margin-bottom: 10px;
}
.col-7 {
  padding: 50px 0px 50px 0px;
}
table {
  max-width: 800px;
  margin: 0 auto 0 auto;
}
table tbody {
  background: #fff;
}
thead tr th {
  text-align: center;
  background-color: #f8c291;
}
table.table-bordered > thead > tr > th {
  border: 3px solid #f8f5e4;
}
table.table-bordered > tbody > tr > td {
  border: 3px solid #f8f5e4;
}
table.table-bordered > tbody > tr > th {
  border: 3px solid #f8f5e4;
}
tbody tr {
  text-align: center;
}
tbody td {
  padding-top: 18px;
}
.age {
  font-size: 1.5em;
}
.yellow {
  color: #f9850c;
}
.green {
  color: #8fe2b2;
}
.blue {
  color: #1592e6;
}
.greenT {
  color: #52b700;
}
</style>
